import React, { lazy } from 'react';
const partners = [{
  name: 'BBB Accredited Business',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/bbb-1920w.png',
  link: 'https://www.bbb.org/us/az/yuma/profile/pressure-washer/busy-drones-cleaners-llc-1126-1000151420'
}, {
  name: 'Yuma County Chamber of Commerce',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/YCCC-Logo-no-background_826d53ec-5056-a36f-23c4aa2cc2135b26-1920w.png'
}, {
  name: 'U.S. Small Business Administration',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/OIPsba-1920w.webp'
}, {
  name: 'SBDC Arizona Western College',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/SBDC+-+Arizona+Western+College+logo+%281%29+%281%29-1920w.png'
}, {
  name: 'National Bank of Arizona',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/IMG_8746%281%29-1920w.jpeg'
}, {
  name: 'Arizona Dept of Economic Security',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/A-W-1920w.png'
}, {
  name: 'Arizona @ Work',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/Arizona-atwork-logo-1920w.png'
}, {
  name: 'Arizona Western Entrepreneurial College',
  logo: 'https://lirp.cdn-website.com/d7afec65/dms3rep/multi/opt/awc-1920w.png'
}];
export function TrustedPartners() {
  const renderLogo = (partner: (typeof partners)[0], index: number) => {
    const img = <img src={partner.logo} alt={partner.name} className="h-10 md:h-[60px] w-auto object-contain shrink-0" loading="lazy" data-id="element-176" />;
    return <div key={`${partner.name}-${index}`} className="shrink-0 px-10 md:px-12 flex items-center" data-id="element-177">
        {partner.link ? <a href={partner.link} target="_blank" rel="noopener noreferrer" className="block" data-id="element-178">
            {img}
          </a> : img}
      </div>;
  };
  return <section className="bg-[#F5F7FA] py-16 lg:py-20 font-heading overflow-hidden" data-id="element-179">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10" data-id="element-180">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] text-center uppercase tracking-tight" data-id="element-181">
          Elite Partners.
        </h2>
      </div>

      <div className="relative w-full overflow-hidden group" data-id="element-182">
        <style data-id="element-183">{`
          @keyframes marquee-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            animation: marquee-scroll 40s linear infinite;
          }
          .group:hover .marquee-track {
            animation-play-state: paused;
          }
        `}</style>

        <div className="marquee-track flex w-max" data-id="element-184">
          {/* First set */}
          {partners.map((partner, i) => renderLogo(partner, i))}
          {/* Duplicate set for seamless loop */}
          {partners.map((partner, i) => renderLogo(partner, i + partners.length))}
        </div>
      </div>
    </section>;
}